import React from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from '@thd-olt-component-react/router';
import PropTypes from 'prop-types';
import { DropDownItem } from '@thd-olt-component-react/core-ui';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useStore } from '../../store';
import { clickEvents } from '../../utils/analytics';
import { EXP_ROUTES } from '../../utils/constants';
import ActionsDropdownWrapper from './ActionsDropdownWrapper';

const _JobApplicantActionDropdown = ({ applicant }) => {

  const navigate = useNavigate();

  const {
    jobApplicantStore: {
      acceptJobApplicant,
      rejectJobApplicant,
      jobPostingMetadata: {
        jobPostingId
      }
    }
  } = useStore();

  const isHiredEnabled = useConfigService('fs:isHiredEnabled');

  const actions = [
    {
      name: 'View Profile',
      show: true,
      onClick: () => {
        clickEvents.jobApplicantsAction('view profile');
        navigate(EXP_ROUTES.APPLICANTS_PROFILE(jobPostingId, applicant.candidateId));
      }
    },
    {
      name: (<a href={`mailto:${applicant.email}`} className="my-dashboard__selectlink">Email</a>),
      show: true,
      onClick: () => {
        clickEvents.jobApplicantsAction('email');
      }
    },
    {
      name: (<a href={`tel:${applicant.phoneNumber}`} className="my-dashboard__selectlink">Call</a>),
      show: !!applicant.phoneNumber,
      onClick: () => {
        clickEvents.jobApplicantsAction('call');
      }
    },
    {
      name: 'Hire Applicant',
      show: isHiredEnabled && applicant.status !== 'hired',
      onClick: () => {
        clickEvents.jobApplicantsAction('mark as hired');
        acceptJobApplicant(applicant.applicantId);
      }
    },
    {
      name: 'Reject Applicant',
      show: isHiredEnabled && applicant.status !== 'not_hired',
      onClick: () => {
        clickEvents.jobApplicantsAction('reject');
        rejectJobApplicant(applicant.applicantId);
      }
    }
  ];

  return (
    <ActionsDropdownWrapper testId={`applicant-action-dropdown-${applicant.applicantId}`}>
      {actions
        .filter((action) => action.show)
        .map((action, i) => {
          return (
            <DropDownItem
              key={i}
              onClick={action.onClick}
            >
              <span className="mobile-list-dropdown">{action.name}</span>
            </DropDownItem>
          );
        })}
    </ActionsDropdownWrapper>
  );
};

const JobApplicantActionDropdown = observer(_JobApplicantActionDropdown);
export default JobApplicantActionDropdown;

JobApplicantActionDropdown.propTypes = {
  applicant: PropTypes.shape({
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    status: PropTypes.string,
    applicantId: PropTypes.number,
    candidateId: PropTypes.number
  }).isRequired
};
